module.exports = __webpack_public_path__ + "static/media/design5.d9652204.png";